export const CouponActionTypes = {
  // Fetch coupons
  GET_COUPONS: "GET_COUPONS",

  // Add coupon
  ADD_COUPON: "ADD_COUPON",

  // Update coupon
  UPDATE_COUPON: "UPDATE_COUPON",

  // Delete coupon
  DELETE_COUPON: "DELETE_COUPON",

  // Edit coupon
  EDITING_COUPON: "EDITING_COUPON",
};
